"use client";

import { motion } from "motion/react";
import { Icon } from "@iconify/react";

export default function MapSection() {
  return (
    <section className="px-6 pb-24">
      <div className="max-w-[83.75rem] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          // Uses --height-150 (750px) token concept, but clamped for better UX
          className="w-full h-[500px] md:h-[600px] rounded-[2rem] overflow-hidden border border-border dark:border-dark_border shadow-lg relative group bg-hero-bg dark:bg-dark_b"
        >
          {/* Map Iframe */}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.2912092330123!2d72.99969417508537!3d19.11363058210743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7bf06714a2fd1%3A0xa5be9a8885f3d9c0!2sRupa%20Solitaire%2C%20Millennium%20Business%20Park%2C%20Mahape%2C%20Navi%20Mumbai%2C%20Maharashtra%20400710!5e0!3m2!1sen!2sin!4v1707040000000!5m2!1sen!2sin"
            width="100%"
            height="100%"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-full grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out mix-blend-multiply dark:mix-blend-normal opacity-90 group-hover:opacity-100"
            style={{ border: 0 }}
            title="Office Location"
          ></iframe>

          {/* Floating Overlay Label */}
          <div className="absolute bottom-8 left-8 bg-white dark:bg-dark_b backdrop-blur-md px-6 py-4 rounded-2xl shadow-xl border border-border dark:border-dark_border flex items-center gap-4 pointer-events-none z-10">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary animate-pulse">
              <Icon icon="ion:location" width="24" />
            </div>
            <div>
              <p className="text-13 text-muted dark:text-foottext uppercase tracking-widest font-bold">
                Locate Us
              </p>
              <p className="text-midnight_text dark:text-white font-bold text-16">
                Rupa Solitaire, Navi Mumbai
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
